import '../scss/main.scss';

import $ from 'jquery';
import * as bootstrap from 'bootstrap';

window.$ = $;
window.jQuery = $;
window.bootstrap = bootstrap;

import 'parsleyjs';
import 'parsleyjs/dist/i18n/nl';
import 'parsleyjs/dist/i18n/nl.extra';

import './plugins/jquery.selector.focusable';
import './plugins/jquery-pincode-autotab';

import { initAos } from './modules/aos';
import { initFloatLabels } from './modules/float-labels';
import { initForm } from './modules/form';

document.addEventListener('DOMContentLoaded', async () => {
	initAos();
	initFloatLabels();
	initForm();

	if (document.querySelector('.js-participants-table')) {
		const { initParticipantsTable } =
			await import('./modules/participants-table');

		initParticipantsTable();
	}
});
